import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { BuscarPessoaModel } from "../models/pessoa/chamadas/buscarPessoaModel";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setModalDeletarPessoa, setPagePessoa } from "../redux/slices/pessoa/pessoaSlice";
import { setModalPessoaContaFinanceira } from "../redux/slices/contaFinanceira/contaFinanceiraSlice";

export const cadastrarPessoa = createAsyncThunk("/Pessoa/CadastrarPessoa", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/Pessoa/CadastrarPessoa", payload.value);
    toastSucess("A pessoa foi cadastrada com sucesso");
    if (payload.origem === "contaFinanceira") {
      dispatch(setModalPessoaContaFinanceira(true));
    } else {
      dispatch(setPagePessoa("geral"));
    }
    dispatch(setLoading(false));

    dispatch(buscarPessoa(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarPessoa = createAsyncThunk("/Pessoa/BuscarPessoa", async (args: BuscarPessoaModel) => {
  try {
    const data = await api.get("/Pessoa/BuscarPessoa", {
      params: args,
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const listarCategoriaPessoa = createAsyncThunk("/Pessoa/ListarCategoriaPessoa", async () => {
  try {
    const data = await api.get("/Pessoa/ListarCategoriaPessoa");
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarPessoa = createAsyncThunk("/Pessoa/AtualizarPessoa", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/Pessoa/AtualizarPessoa", payload.value);
    toastSucess("A pessoa foi atualizada com sucesso");
    dispatch(setPagePessoa("geral"));
    dispatch(setLoading(false));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const atualizarPessoaAtivo = createAsyncThunk("/Pessoa/AtualizarPessoaAtivo", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/Pessoa/AtualizarPessoaAtivo", null, {
      params: payload.value,
    });
    toastSucess("Status de ativo da pessoa foi atualizado com sucesso");
    dispatch(setLoading(false));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarPessoa = createAsyncThunk("/Pessoa/DeletarPessoa", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/Pessoa/DeletarPessoa", {
      params: { id: payload.value },
    });
    toastSucess("A pessoa foi removida com sucesso");
    dispatch(setModalDeletarPessoa(false));
    dispatch(setLoading(false));

    dispatch(buscarPessoa(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
